import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 98%;
  margin: auto;
  padding: 30px 0 20px 0;
`;

export const Texto = styled.h1`
  font-size: 25pt;
  font-weight: 800;
  margin: 0 0px;
  color: var(--primary-color-sefaz);
`;

export const ContainerIcon = styled.div`
  width: 38px;
  height: 40px;
  margin-top: 5px;
  text-align: center;
  display: flex;
  align-items: center;
  transition-property: background-color;
  transition-duration: 1s;
  border-radius: 50%;
  cursor: pointer;

  span {
    color: var(--primary-color-sefaz);
    margin: auto;
  }

  &:hover {
    background-color: #d5d5d5;
  }
`;
